export interface ArtifactStatusDto {
  name: string;
  isResolved: boolean;
  displayValue?: string;
  dependsOn: string[];
}

export interface ChoiceOption {
  id: string;
  label: string;
  description?: string;
}

export interface StructuredChoices {
  prompt: string;
  options: ChoiceOption[];
  allowCustomInput: boolean;
}

export interface ChatMessageDto {
  role: string;
  content: string;
  choices?: StructuredChoices;
}

export interface RuleCreationChatSessionDto {
  sessionId: string;
  artifacts: ArtifactStatusDto[];
  messages: ChatMessageDto[];
}

export interface StartChatRequest {
  functionalLocationId: string;
}

export interface StartModificationChatRequest {
  ruleId: string;
}

export interface ChatRequestDto {
  sessionId: string;
  message: string;
  selectedChoiceId?: string;
}

export interface ValidationDto {
  success: boolean;
  details?: string;
}

export interface EvaluationConfigDto {
  interpolationInterval: string;
  evaluationPeriod: string;
}

export interface ValidatedPiPointInfoDto {
  tag: string;
  webId: string;
  server: string;
  pointType: string;
  engineeringUnits: string;
  descriptor?: string;
  span: number;
  zero: number;
  digitalSetName?: string;
}

export interface ChatSseEvent {
  eventType: string;
  sessionId?: string;
  content?: string;
  choices?: StructuredChoices;
  artifactStatus?: ArtifactStatusDto[];
  createdRuleId?: string;
  validation?: ValidationDto;
  activationCondition?: string;
  monitoringEquation?: string;
  evaluationConfig?: EvaluationConfigDto;
  validatedPiPoints?: ValidatedPiPointInfoDto[];
}

export const SSE_EVENT_TYPES = {
  SESSION: 'session',
  TOKEN: 'token',
  CHOICES: 'choices',
  ARTIFACTS: 'artifacts',
  COMPLETED: 'completed',
  DONE: 'done',
  ERROR: 'error',
} as const;
